import React from "react";
//import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";

//import { selectNavCommunity } from "Selectors";
//import { checkAuthentication } from "./checkAuthentication";

import Community from "Community";
import Home from "Community/Home";
//import CommunityMediasByType from "Community/admin/CommunityMediasByType";
//import AlbumPage from "Community/admin/AlbumPage/AlbumPage";
//import AlbumListPage from "Community/admin/AlbumListPage/AlbumListPage";
import Settings from "Settings";
import MyMedias from "MyMedias";
import Archive from "Archive";
import CategoriesList from "CategoriesList";
//import Library from "Library/Library";

// import { initStore } from "thunks";

/*const Home = connect(state => ({ navCommunity: selectNavCommunity(state) }))(
  ({ navCommunity }) => (
    <Redirect to={`/community/${navCommunity.name}/${navCommunity.id}`} />
  )
);*/

export const urls = {
  index: "/",
  community: "/community/:communityName/:communityId",
  communityMediasByType: "/community/:communityName/:communityId/:mediaType",
  albumPage: "/community/:communityName/:communityId/album/:albumId",
  albumListPage: "/community/:communityName/:communityId/albums",
  myMedias: "/community/:communityName/:communityId/my-medias",
  settings: "/community/:communityName/:communityId/settings",
  categories: "/community/:communityName/:communityId/categories",
  archive: "/community/:communityName/:communityId/archive",
  library: "/community/:communityName/:communityId/library",
  notFound: "*"
};

export const getRoutes = () => {
  return (
    <Switch>
      <Route exact path="/" component={Home} />
      <Route path={urls.myMedias} component={MyMedias} />
      <Route path={urls.archive} component={Archive} />
      <Route path={urls.settings} component={Settings} />
      <Route path={urls.categories} component={CategoriesList} />

      {/*}<Route
        onUpdate={() => window.scrollTo(0, 0)}
        path={urls.albumListPage}
        component={checkAuthentication(AlbumListPage)}
      />
      <Route
        path={urls.library}
        onUpdate={() => window.scrollTo(0, 0)}
        component={checkAuthentication(Library)}
      />
      <Route
        path={urls.albumPage}
        onUpdate={() => window.scrollTo(0, 0)}
        component={checkAuthentication(AlbumPage)}
      />
      <Route
        path={urls.communityMediasByType}
        component={checkAuthentication(CommunityMediasByType)}
      />*/}
      <Route
        path={urls.community}
        onUpdate={() => window.scrollTo(0, 0)}
        component={Community}
      />
    </Switch>
  );
};



// WEBPACK FOOTER //
// ./src/router/getRoutes.js